import {DatePipe} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {Injectable, Optional, SkipSelf} from '@angular/core';
import {ApiService, CsvPropertiesConfirmResponse, CsvPropertiesMapRequest, EnvironmentModel, FileUploadService, SolutionEnvironmentModel} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PeopleImportService extends ApiService {

    public controller = 'ImportUsers';

    public constructor(protected readonly client: HttpClient,
                       protected readonly environment: EnvironmentModel,
                       private readonly fileUploader: FileUploadService,
                       @SkipSelf() @Optional() protected solutionEnvironment?: SolutionEnvironmentModel,
                       @Optional() protected readonly logger?: NGXLogger,
                       @Optional() protected readonly datePipe?: DatePipe) {
        super(client, environment, solutionEnvironment, logger, datePipe);
    }

    public startSession(file: File, onResponse?: (result?: CsvPropertiesMapRequest) => void): Observable<number> {
        const uploadPath = this.controller + '/start';
        return this.fileUploader.uploadFile(uploadPath, file, undefined, (body?: any) => {
            if (onResponse) {
                if (body) {
                    onResponse(body as CsvPropertiesMapRequest);
                } else {
                    onResponse(undefined);
                }
            }
        });
    }

    public confirmImport(confirmation: CsvPropertiesConfirmResponse): Observable<any> {
        return this.client.post(this.url('confirm'), confirmation, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }
}
